export default "__VITE_PUBLIC_ASSET__1d7438df__"